import { path, httpService } from '@commons';

/////////////////////////////////////////////////////////////////////////////////
const args = { ...path, path: '/estoque/entrada' };
/////////////////////////////////////////////////////////////////////////////////

export function createEntradaEstoque(payload) {
  return httpService.post(args, payload);
}

export function updateEntradaEstoque(payload) {
  const { id } = payload

  return httpService.put({ ...args, args: `/${id}` }, payload);
}

export function listEntradaEstoque(param) {
  return httpService.get({ ...args, args: param });
}

export function listAllEntradaEstoque(idFazenda, datas, where) {
  return httpService.get({ ...args, path: `/estoque/entrada/filterResumed?propriedade=${idFazenda}&datas=${datas}${where}` });
}

export function listAllEntradaEstoquePdf(idFazenda, datas, where) {
  return httpService.getPdf({ ...args, path: `/estoque/entrada/filterResumed/pdf?propriedade=${idFazenda}&datas=${datas}${where}` });
}

export function findEntradaEstoque(id) {
  return httpService.get({ ...args, args: `/${id}` });
}

export function findAllEntradaEstoque() {
  return httpService.get({ ...args, path: '/estoque/entrada/all' });
}

export function deleteEntradaEstoque(id) {
  return httpService.del({ ...args, args: `/${id}` });
}

export function attachFiles(notaId, payload) {
  return httpService.putAttachFiles({ ...args, args: `/attachFiles/${notaId}` }, payload);
}

export function deleteAttachFiles(notaId, filesIdList) {
  return httpService.putDeleteFiles({ ...args, args: `/deleteFiles/${notaId}` }, filesIdList);
}

export function attachFilesToContaPagar(contaId, payload) {
  const contaPagarArgs = { ...path, path: '/contas/pagar' };
  return httpService.putAttachFiles({ ...contaPagarArgs, args: `/attachFiles/${contaId}` }, payload);
}

export function deleteAttachFilesFromContaPagar(contaId, filesIdList) {
  const contaPagarArgs = { ...path, path: '/contas/pagar' };
  return httpService.putDeleteFiles({ ...contaPagarArgs, args: `/deleteFiles/${contaId}` }, filesIdList);
}

export function entradaPodeSerEditadaExcluida(id) {
  return httpService.get({ ...args, path: '/estoque/entrada/entradaPodeSerEditadaExcluida/' + id });
}

export function readXmlVerificarArquivoEFornecedor(xml) {
  var bodyFormData = new FormData();
  bodyFormData.append('xml', xml);

  return httpService.postFile({ ...args, path: '/estoque/entrada/importarXML/verificarArquivoEFornecedor/' }, bodyFormData);
}

export function readXmlFile(xml, naturezaOperacao, localEstoqueId, propriedade) {
  var bodyFormData = new FormData();
  bodyFormData.append('xml', xml);

  return httpService.postFile({ ...args, path: '/estoque/entrada/importarXML/arquivo/' + naturezaOperacao.id + "/" + localEstoqueId + "/" + propriedade  }, bodyFormData);
}

export function visualizarDanfeXmlManualFile(idNota) {
  return httpService.getPdf({ ...args, path: `/estoque/entrada/gerarDanfeXmlManual/${idNota}` });
}
